<template>
  <div class="edit-hymn">
    <section>
      <div class="columns">
        <div class="column">
          <b-field label="Title">
            <b-input
              type="text"
              v-model="hymn.title"
              placeholder="Title"
              required
            ></b-input>
          </b-field>
          <b-field label="Swahili Title">
            <b-input
              type="text"
              v-model="hymn.swahiliTitle"
              placeholder="Swahili Title"
              required
            ></b-input>
          </b-field>
          <b-field label="Hymn Code">
            <b-input
              type="text"
              v-model="hymn.hymnCode"
              placeholder="Code"
              required
            ></b-input>
          </b-field>
          <b-field label="Author">
            <b-input
              type="text"
              v-model="hymn.author"
              placeholder="Author"
              required
            ></b-input>
          </b-field>
          <b-notification type="is-info is-light" indefinite>
            <img
              src="data:image/png;base64,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"
            />
            <b-field label="Time Signature">
              <b-input
                type="text"
                v-model="hymn.timeSignature"
                placeholder="Time Signature"
                required
              ></b-input>
            </b-field>
          </b-notification>
          <b-field label="Parent Category">
            <v-select
              v-model="hymn.parentCategory"
              :options="parentCategories"
            ></v-select>
          </b-field>
          <b-field label="Category">
            <v-select v-model="hymn.category" :options="categories"></v-select>
          </b-field>
          <b-notification type="is-success is-light" indefinite>
            <b-notification type="is-success" indefinite>
              <p>
                The image uploaded here should be one page. If you have sheet
                music that is in PDF format, please attach it as a resource
                below.
              </p>
              <p>Sheet Music (One Page) : {{ hymn.sheetMusic }}</p>
            </b-notification>
            <p>Uploading : {{ this.isUploading }}</p>
            <b-field label="Sheet Music (Image) - Upload">
              <b-upload class="file-label" v-model="filePath">
                <span class="file-cta">
                  <span class="file-label">Click to Upload</span>
                </span></b-upload
              >
            </b-field>
          </b-notification>
          <b-notification type="" indefinite>
            <p>
              Link extra resource here. This can be a Youtube Video, Chords in
              PDF format or Sheet Music in PDF format.
            </p>
            <button class="button" @click="addResource">+ Add Resource</button>
            <div v-for="(resource, index) in hymn.resources" :key="index">
              <div class="resource">
                <button @click="removeResource(index)">x Remove</button>
                <b-field label="Resource Type">
                  <v-select
                    v-model="resource.resourceType"
                    :options="resourceTypes"
                    required
                  ></v-select>
                </b-field>
                <b-field label="Resource Description">
                  <b-input
                    type="text"
                    v-model="resource.resourceDescription"
                    placeholder="Resource Description"
                    required
                  ></b-input>
                </b-field>
                <b-field label="Resource Link">
                  <b-input
                    type="text"
                    v-model="resource.resourceLink"
                    placeholder="Resource Link"
                    required
                  ></b-input>
                </b-field>
              </div>
            </div>
          </b-notification>
        </div>
        <div class="column">
          <b-notification type="is-info is-light" indefinite>
            <p>
              <strong>Extra Info : </strong>Use this to add extra information
              like
            </p>
            <ul>
              <li>Who arranged the song</li>
              <li>Scripture references for this song</li>
            </ul>
            <b-field label="Extra Information">
              <b-input
                type="textarea"
                rows="2"
                v-model="hymn.scriptureReference"
                placeholder="Extra Information"
                required
              ></b-input>
            </b-field>
          </b-notification>
          <b-field label="English Lyrics">
            <b-input
              type="textarea"
              rows="15"
              v-model="hymn.content"
              placeholder="Lyrics"
              required
            ></b-input>
          </b-field>
          <b-field label="Swahili Lyrics">
            <b-input
              type="textarea"
              rows="15"
              v-model="hymn.swahiliContent"
              placeholder="Swahili Lyrics"
            ></b-input>
          </b-field>
          <b-notification type="is-warning is-light" indefinite>
            <b-notification type="is-danger is-light" indefinite>
              <p><strong>Chords : </strong> Use this for chords to this song</p>
              <p>
                IMPORTANT : Chords should be submitted in Chord Pro format. To
                convert manually go to
                <a target="_blank" href="https://ultimate.ftes.de/"
                  >https://ultimate.ftes.de</a
                >
              </p>
            </b-notification>
            <b-notification type="is-info is-light" indefinite>
              <p>
                To convert here paste in the chords from Ultimate Guitar and
                click the convert button. If you do not know what you are doing
                STOP! :-)
              </p>
            </b-notification>
            <button class="button is-info" @click="convertChords">
              Convert to Chord Pro
            </button>
            <b-field label="Chords">
              <b-input
                type="textarea"
                rows="15"
                v-model="hymn.chords"
                placeholder="Chords"
              ></b-input>
            </b-field>
          </b-notification>
        </div>
      </div>
      <div class="controls">
        <button class="button is-primary" @click="saveHymn">Save</button>
        <button v-if="hymnId" class="button is-danger" @click="deleteHymn">
          {{ deleteHymnText }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import { firestore, storage } from "@/firebase";
import ChordSheetJS from "chordsheetjs";
import { ToastProgrammatic as Toast } from "buefy";

var db = firestore;
var firebaseStorage = storage;

import { index } from "@/algolia_util";

export default {
  name: "EditHymn",
  props: ["hymnId"],
  data() {
    return {
      filePath: null,
      isUploading: false,
      categories: [],
      parentCategories: [],
      deletingHymn: false,
      hymn: {
        title: null,
        content: null,
        author: null,
        category: null,
        parentCategory: null,
        scriptureReference: null,
        sheetMusic: null,
        timeSignature: null,
        hymnCode: null,
        swahiliTitle: null,
        swahiliContent: null,
        chords: null,
        resources: [],
      },
    };
  },
  mounted() {
    // Pull all parent categories
    db.collection("ParentCategories")
      .get()
      .then((snapshot) => {
        let tags = snapshot.docs.map((d) => {
          var data = d.data();
          data.id = d.id;
          data.label = data.name;
          data.code = d.id;
          return data;
        });
        this.parentCategories = tags;
      });
    //Pull all tags
    db.collection("Categories")
      .get()
      .then((snapshot) => {
        let tags = snapshot.docs.map((d) => {
          var data = d.data();
          data.id = d.id;
          let parent = this.parentCategories.find((p) => p.id == data.parentId);
          if (typeof parent == "undefined") {
            data.label = data.name;
          } else {
            data.label = parent.name + " // " + data.name;
          }
          data.code = d.id;
          return data;
        });
        this.categories = tags;
      });

    if (this.hymnId) {
      // Pull linked tags
      db.collection("HymnCategory")
        .where("hymnId", "==", this.hymnId)
        .onSnapshot((snapshot) => {
          let tags = snapshot.docs.map((d) => {
            return d.data().categoryId;
          });
          this.hymn.tags = tags;
        });

      let ref = `/Hymns/${this.hymnId}`;
      db.doc(ref)
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document exists and available for editing");
            let hymnData = doc.data();
            console.log(hymnData);
            this.hymn.title = hymnData.title;
            this.hymn.hymnCode = hymnData.hymnCode;
            this.hymn.content = hymnData.content;
            this.hymn.author = hymnData.author;
            this.hymn.swahiliTitle = hymnData.swahiliTitle;
            this.hymn.swahiliContent = hymnData.swahiliContent;
            this.hymn.sheetMusic = hymnData.sheetMusic;
            this.hymn.chords = hymnData.chords;
            this.hymn.category = this.categories.find(
              (c) => c.id == hymnData.categoryId
            );
            this.hymn.parentCategory = this.parentCategories.find(
              (p) => p.id == hymnData.parentCategoryId
            );
            this.hymn.scriptureReference = hymnData.scriptureReference;
            this.hymn.timeSignature = hymnData.timeSignature;
            this.hymn.resources =
              hymnData.resources != null ? hymnData.resources : [];
          } else {
            Toast.open({
              message: "No such document available",
              type: "is-danger",
              duration: 3000,
              position: "is-bottom",
            });
            this.$router.go(-1);
          }
        })
        .catch((error) => {
          console.log("error getting document : " + error);
        });
    } else {
      console.log("creating a new expense");
    }
  },
  methods: {
    addResource: function () {
      console.log(this.hymn);
      this.hymn.resources.push({
        resourceType: null,
        resourceLink: null,
        resourceDescription: null,
      });
    },
    uploadImage: function () {
      console.log("Uploading Image....");
    },
    convertChords: function () {
      const chordSheet = this.hymn.chords.substring(1);

      const parser = new ChordSheetJS.UltimateGuitarParser();
      var song = parser.parse(chordSheet);

      const formatter = new ChordSheetJS.ChordProFormatter();
      const disp = formatter.format(song);
      this.hymn.chords = disp;
    },
    removeResource: function (index) {
      this.hymn.resources.splice(index, 1);
    },
    deleteHymn: function () {
      if (this.deletingHymn) {
        let ref = `/Hymns/`;
        db.collection(ref)
          .doc(this.hymnId)
          .delete()
          .then(() => {
            console.log("hymn deleted");
            Toast.open({
              message: "The hymn has been deleted",
              type: "is-success",
              duration: 3000,
              position: "is-bottom",
            });
            // Remove Algolia index
            index.deleteObject(this.hymnId).then(() => {
              console.log("Hymn deleted from Algolia", this.hymnId);
            });
            this.$router.go(-1);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.deletingHymn = true;
      }
    },
    saveHymn: function () {
      var dataToSave = {
        title: this.hymn.title,
        content: this.hymn.content,
        author: this.hymn.author,
        scriptureReference: this.hymn.scriptureReference,
        timeSignature: this.hymn.timeSignature,
        categoryId: this.hymn.category != null ? this.hymn.category.id : null,
        parentCategoryId:
          this.hymn.parentCategory != null ? this.hymn.parentCategory.id : null,
        hymnCode: parseInt(this.hymn.hymnCode),
        chords: this.hymn.chords != null ? this.hymn.chords : "",
        swahiliContent:
          this.hymn.swahiliContent != null ? this.hymn.swahiliContent : "",
        sheetMusic: this.hymn.sheetMusic != null ? this.hymn.sheetMusic : "",
        swahiliTitle:
          this.hymn.swahiliTitle != null ? this.hymn.swahiliTitle : "",
        resources: this.hymn.resources.map((r) => {
          return {
            resourceType: r.resourceType,
            resourceLink: r.resourceLink,
            resourceDescription: r.resourceDescription,
          };
        }),
      };
      console.log(dataToSave);
      var saveSuccessFullHanlder = () => {
        console.log("Successfull added hymn");
        Toast.open({
          message: "The hymn has been recorded",
          type: "is-success",
          duration: 3000,
          position: "is-bottom",
        });
        this.$router.go(-1);
      };

      if (this.hymnId) {
        let ref = `/Hymns`;
        db.collection(ref)
          .doc(this.hymnId)
          .update(dataToSave)
          .then(saveSuccessFullHanlder);

        // Save data to Algolia
        dataToSave.objectID = this.hymnId;
        index.saveObjects([dataToSave]).then(() => {
          console.log("Hymn updated on Algolia");
        });
      } else {
        let ref = `/Hymns`;
        let docRef = db.collection(ref).doc();
        docRef
          .set(dataToSave)
          .then(saveSuccessFullHanlder)
          .catch((error) => {
            console.log("Error adding hymn : " + error);
          });

        // Save data to Algolia
        dataToSave.objectID = docRef.id;
        index.saveObjects([dataToSave]).then(() => {
          console.log("Hymn added on Algolia");
        });
      }
    },
  },
  computed: {
    deleteHymnText: function () {
      if (this.deletingHymn) {
        return "Confirm Delete";
      } else {
        return "Delete";
      }
    },
    resourceTypes: function () {
      return ["YOUTUBE", "CHORDS_CHART", "GENERIC_FILE"];
    },
  },
  watch: {
    filePath: function () {
      console.log("File Selected");
      console.log(firebaseStorage);
      var storageRef = firebaseStorage.ref("sheet-music");
      var thisRef = storageRef.child(this.filePath.name);
      this.isUploading = true;
      thisRef.put(this.filePath).then((snapshot) => {
        console.log(snapshot);
        console.log("Uploaded a blob or file! : " + thisRef.fullPath);
        this.isUploading = false;
        thisRef.getDownloadURL().then((url) => {
          this.hymn.sheetMusic = url;
        });
      });
    },
  },
};
</script>

<style>
.controls button {
  margin-left: 10px;
}

.resource {
  margin-top: 5px;
  padding: 10px;
  background: lightgray;
  margin-bottom: 5px;
}
</style>